export function index()
{
    return axios.get(route('api.manage.companies.roles') + '?limit=999&include=permissions,usersCount')
        .then(response => response.data);
}

export function store(data)
{
    return axios.post(route('api.manage.companies.roles') + '?include=permissions,usersCount', data)
        .then(response => response.data);
}

export function show(roleId)
{
    return axios.get(route('api.manage.roles.show', { roleId: roleId }) + '?include=permissions,usersCount');
}

export function update(roleId, data)
{
    return axios.patch(route('api.manage.roles.update', { roleId: roleId }) + '?include=permissions,usersCount', data)
        .then(response => response.data);
}

export function destroy(roleId)
{
    return axios.delete(route('api.manage.roles.destroy', { roleId: roleId }));
}
